import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import logoNeuroResearch from "@/assets/logo-neuroresearch.webp";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-16">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          <div>
            <Link to="/fr" className="inline-block mb-4">
              <img 
                src={logoNeuroResearch} 
                alt="NeuroResearch Foundation" 
                width={179}
                height={48}
                loading="lazy"
                decoding="async"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-muted-foreground leading-relaxed">
              Dédiés à la recherche sur les maladies neurologiques pour un avenir meilleur.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Recherche</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/fr/research-projects" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Projets de Recherche</Link></li>
              <li><Link to="/fr/collaborations" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Collaborations</Link></li>
              <li><Link to="/fr/clinical-trials" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Essais Cliniques</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Participer</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <Link 
                  to="/fr" 
                  onClick={() => {
                    setTimeout(() => {
                      const donationSection = document.getElementById('donation-section');
                      if (donationSection) {
                        donationSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }}
                  className="hover:text-primary transition-colors"
                >
                  Faire un Don
                </Link>
              </li>
              <li><Link to="/fr/volunteering" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Bénévolat</Link></li>
              <li><Link to="/fr/events" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Événements</Link></li>
              <li><Link to="/fr/newsletter" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Newsletter</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-card-foreground">Restez Informé</h4>
            <p className="text-muted-foreground mb-4">
              Abonnez-vous pour recevoir les dernières nouvelles sur notre recherche
            </p>
            <div className="flex gap-2">
              <Button 
                variant="secondary"
                asChild
              >
                <Link to="/fr/newsletter">S'abonner</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="border-t border-border pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-muted-foreground">
              © 2024 Green Life Bcn Foundation. Tous droits réservés.
            </div>
            <div className="flex gap-6 text-muted-foreground">
              <Link to="/fr/privacy" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Confidentialité</Link>
              <Link to="/fr/conditions-utilisation" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Conditions</Link>
              <Link to="/fr/contact" onClick={() => window.scrollTo(0, 0)} className="hover:text-primary transition-colors">Contact</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
